function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.datepicker = t() : e.datepicker = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(a) {
      if (t[a]) return t[a].exports;
      var r = t[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return e[a].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, a) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: a
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var a = Object.create(null);
      if (n.r(a), Object.defineProperty(a, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(a, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return a;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    e.exports = n(1);
  }, function (e, t, n) {
    function a(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = [],
            a = !0,
            r = !1,
            i = void 0;

        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0) {
            ;
          }
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            a || null == s["return"] || s["return"]();
          } finally {
            if (r) throw i;
          }
        }

        return n;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    n(2);

    var r = [],
        i = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        o = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        s = {
      t: "top",
      r: "right",
      b: "bottom",
      l: "left",
      c: "centered"
    },
        c = function c() {},
        l = ["click", "focusin", "keydown", "input"];

    function d(e) {
      return Array.isArray(e) ? e.map(d) : "[object Object]" === {}.toString.call(e) ? Object.keys(e).reduce(function (t, n) {
        return t[n] = d(e[n]), t;
      }, {}) : e;
    }

    function u(e, t) {
      var n = e.calendar.querySelector(".qs-overlay"),
          a = n && !n.classList.contains("qs-hidden");
      t = t || new Date(e.currentYear, e.currentMonth), e.calendar.innerHTML = [h(t, e, a), f(t, e, a), v(e, a)].join(""), a && setTimeout(function () {
        return M(!0, e);
      }, 10);
    }

    function h(e, t, n) {
      return '\n    <div class="qs-controls '.concat(n ? "qs-blur" : "", '">\n      <div class="qs-arrow qs-left"></div>\n      <div class="qs-month-year">\n        <span class="qs-month">').concat(t.months[e.getMonth()], '</span>\n        <span class="qs-year">').concat(e.getFullYear(), '</span>\n      </div>\n      <div class="qs-arrow qs-right"></div>\n    </div>\n  ');
    }

    function f(e, t, n) {
      var a = t.currentMonth,
          r = t.currentYear,
          i = t.dateSelected,
          o = t.maxDate,
          s = t.minDate,
          c = t.showAllDates,
          l = t.days,
          d = t.disabledDates,
          u = t.disabler,
          h = t.noWeekends,
          f = t.startDay,
          v = t.weekendIndices,
          m = new Date(),
          y = r === m.getFullYear() && a === m.getMonth(),
          p = q(new Date(e).setDate(1)),
          b = p.getDay() - f,
          D = b < 0 ? 7 : 0;
      p.setMonth(p.getMonth() + 1), p.setDate(0);
      var g = p.getDate(),
          w = [],
          S = D + 7 * ((b + g) / 7 | 0);
      S += (b + g) % 7 ? 7 : 0, 0 !== f && 0 === b && (S += 7);

      for (var M = 1; M <= S; M++) {
        var x = (M - 1) % 7,
            L = l[x],
            P = M - (b >= 0 ? b : 7 + b),
            k = new Date(r, a, P),
            O = k.getDate(),
            Y = P < 1 || P > g,
            C = "",
            j = '<span class="qs-num">'.concat(O, "</span>");
        Y ? (C = "qs-empty", c ? C += " qs-disabled" : j = "") : ((s && k < s || o && k > o || u(k) || d.includes(+k) || h && v.includes(x)) && (C = "qs-disabled"), y && P === m.getDate() && (C += " qs-current")), +k != +i || Y || (C += " qs-active"), w.push('<div class="qs-square qs-num '.concat(L, " ").concat(C, '">').concat(j, "</div>"));
      }

      var N = l.map(function (e) {
        return '<div class="qs-square qs-day">'.concat(e, "</div>");
      }).concat(w);
      if (N.length % 7 != 0) throw "Calendar not constructed properly. The # of squares should be a multiple of 7.";
      return N.unshift('<div class="qs-squares '.concat(n ? "qs-blur" : "", '">')), N.push("</div>"), N.join("");
    }

    function v(e, t) {
      var n = e.overlayPlaceholder,
          a = e.overlayButton,
          r = e.overlayMonths.map(function (e, t) {
        return '\n      <div class="qs-overlay-month" data-month-num="'.concat(t, '">\n        <span data-month-num="').concat(t, '">').concat(e, "</span>\n      </div>\n  ");
      }).join("");
      return '\n    <div class="qs-overlay '.concat(t ? "" : "qs-hidden", '">\n      <div>\n        <input class="qs-overlay-year" placeholder="').concat(n, '" />\n        <div class="qs-close">&#10005;</div>\n      </div>\n      <div class="qs-overlay-month-container">').concat(r, '</div>\n      <div class="qs-submit qs-disabled">').concat(a, "</div>\n    </div>\n  ");
    }

    function m(e, t, n) {
      var a = t.currentMonth,
          r = t.currentYear,
          i = t.calendar,
          o = t.el,
          s = t.onSelect,
          c = t.respectDisabledReadOnly,
          l = t.sibling,
          d = i.querySelector(".qs-active"),
          h = e.textContent;
      (o.disabled || o.readOnly) && c || (t.dateSelected = n ? void 0 : new Date(r, a, h), d && d.classList.remove("qs-active"), n || e.classList.add("qs-active"), p(o, t, n), !n && w(t), l && (y({
        instance: t,
        deselect: n
      }), u(t), u(l)), s(t, n ? void 0 : new Date(t.dateSelected)));
    }

    function y(e) {
      var t = e.instance,
          n = e.deselect,
          a = t.first ? t : t.sibling,
          r = a.sibling;
      a === t ? n ? (a.minDate = a.originalMinDate, r.minDate = r.originalMinDate) : (a.minDate = a.dateSelected, r.minDate = a.dateSelected) : n ? (r.maxDate = r.originalMaxDate, a.maxDate = a.originalMaxDate) : (r.maxDate = r.dateSelected, a.maxDate = r.dateSelected);
    }

    function p(e, t, n) {
      if (!t.nonInput) return n ? e.value = "" : t.formatter !== c ? t.formatter(e, t.dateSelected, t) : void (e.value = t.dateSelected.toDateString());
    }

    function b(e, t, n, a) {
      n || a ? (n && (t.currentYear = n), a && (t.currentMonth = +a)) : (t.currentMonth += e.contains("qs-right") ? 1 : -1, 12 === t.currentMonth ? (t.currentMonth = 0, t.currentYear++) : -1 === t.currentMonth && (t.currentMonth = 11, t.currentYear--)), t.currentMonthName = t.months[t.currentMonth], u(t), t.onMonthChange(t);
    }

    function D(e) {
      if (!e.noPosition) {
        var t = e.el,
            n = e.calendarContainer,
            r = e.position,
            i = e.parent,
            o = r.top,
            s = r.right;
        if (r.centered) return n.classList.add("qs-centered");
        var c = a([i, t, n].map(function (e) {
          return e.getBoundingClientRect();
        }), 3),
            l = c[0],
            d = c[1],
            u = c[2],
            h = d.top - l.top + i.scrollTop,
            f = "".concat(h - (o ? u.height : -1 * d.height), "px"),
            v = "".concat(d.left - l.left + (s ? d.width - u.width : 0), "px");
        n.style.setProperty("top", f), n.style.setProperty("left", v);
      }
    }

    function g(e) {
      return "[object Date]" === {}.toString.call(e) && "Invalid Date" !== e.toString();
    }

    function q(e) {
      if (g(e) || "number" == typeof e && !isNaN(e)) {
        var t = new Date(+e);
        return new Date(t.getFullYear(), t.getMonth(), t.getDate());
      }
    }

    function w(e) {
      e.disabled || (M(!0, e), !e.alwaysShow && e.calendarContainer.classList.add("qs-hidden"), e.onHide(e));
    }

    function S(e) {
      e.disabled || (e.calendarContainer.classList.remove("qs-hidden"), D(e), e.onShow(e));
    }

    function M(e, t) {
      var n = t.calendar;

      if (n) {
        var a = n.querySelector(".qs-overlay"),
            r = a.querySelector(".qs-overlay-year"),
            i = n.querySelector(".qs-controls"),
            o = n.querySelector(".qs-squares");
        e ? (a.classList.add("qs-hidden"), i.classList.remove("qs-blur"), o.classList.remove("qs-blur"), r.value = "") : (a.classList.remove("qs-hidden"), i.classList.add("qs-blur"), o.classList.add("qs-blur"), r.focus());
      }
    }

    function x(e, t, n, a) {
      var r = isNaN(+new Date().setFullYear(t.value || void 0)),
          i = r ? null : t.value;
      if (13 === (e.which || e.keyCode) || "click" === e.type) a ? b(null, n, i, a) : r || t.classList.contains("qs-disabled") || b(null, n, i, a);else if (n.calendar.contains(t)) {
        n.calendar.querySelector(".qs-submit").classList[r ? "add" : "remove"]("qs-disabled");
      }
    }

    function L(e) {
      var t = e.type,
          n = e.target,
          i = n.classList,
          o = a(r.filter(function (e) {
        var t = e.calendar,
            a = e.el;
        return t.contains(n) || a === n;
      }), 1)[0],
          s = o && o.calendar.contains(n);
      if (!(o && o.isMobile && o.disableMobile)) if ("click" === t) {
        if (!o) return r.forEach(w);
        if (o.disabled) return;
        var c = o.calendar,
            l = o.calendarContainer,
            d = o.disableYearOverlay,
            u = o.nonInput,
            h = c.querySelector(".qs-overlay-year"),
            f = !!c.querySelector(".qs-hidden"),
            v = c.querySelector(".qs-month-year").contains(n),
            y = n.dataset.monthNum;
        if (o.noPosition && !s) (l.classList.contains("qs-hidden") ? S : w)(o);else if (i.contains("qs-arrow")) b(i, o);else if (v || i.contains("qs-close")) !d && M(!f, o);else if (y) x(e, h, o, y);else {
          if (i.contains("qs-num")) {
            var p = "SPAN" === n.nodeName ? n.parentNode : n,
                D = ["qs-disabled", "qs-empty"].some(function (e) {
              return p.classList.contains(e);
            });
            return p.classList.contains("qs-active") ? m(p, o, !0) : !D && m(p, o);
          }

          i.contains("qs-submit") && !i.contains("qs-disabled") ? x(e, h, o) : u && n === o.el && S(o);
        }
      } else if ("focusin" === t && o) S(o), r.forEach(function (e) {
        return e !== o && w(e);
      });else if ("keydown" === t && o && !o.disabled) {
        var g = !o.calendar.querySelector(".qs-overlay").classList.contains("qs-hidden");
        13 === (e.which || e.keyCode) && g && s ? x(e, n, o) : 27 === (e.which || e.keyCode) && g && s && M(!0, o);
      } else if ("input" === t) {
        if (!o || !o.calendar.contains(n)) return;
        var q = o.calendar.querySelector(".qs-submit"),
            L = n.value.split("").reduce(function (e, t) {
          return e || "0" !== t ? e + (t.match(/[0-9]/) ? t : "") : "";
        }, "").slice(0, 4);
        n.value = L, q.classList[4 === L.length ? "remove" : "add"]("qs-disabled");
      }
    }

    function P() {
      S(this);
    }

    function k() {
      w(this);
    }

    function O(e, t) {
      var n = q(e),
          a = this.currentYear,
          r = this.currentMonth,
          i = this.sibling;
      if (null == e) return this.dateSelected = void 0, p(this.el, this, !0), i && (y({
        instance: this,
        deselect: !0
      }), u(i)), u(this), this;
      if (!g(e)) throw "`setDate` needs a JavaScript Date object.";
      if (this.disabledDates.some(function (e) {
        return +e == +n;
      }) || n < this.minDate || n > this.maxDate) throw "You can't manually set a date that's disabled.";
      return this.currentYear = n.getFullYear(), this.currentMonth = n.getMonth(), this.currentMonthName = this.months[n.getMonth()], this.dateSelected = n, p(this.el, this), i && (y({
        instance: this
      }), u(i, n)), (a === n.getFullYear() && r === n.getMonth() || t || i) && u(this, n), this;
    }

    function Y(e) {
      return j(this, e, !0);
    }

    function C(e) {
      return j(this, e);
    }

    function j(e, t, n) {
      var a = e.dateSelected,
          r = e.first,
          i = e.sibling,
          o = e.minDate,
          s = e.maxDate,
          c = q(t),
          l = n ? "Min" : "Max",
          d = function d() {
        return "original".concat(l, "Date");
      },
          h = function h() {
        return "".concat(l.toLowerCase(), "Date");
      },
          f = function f() {
        return "set".concat(l);
      },
          v = function v() {
        throw "Out-of-range date passed to ".concat(f());
      };

      if (null == t) e[d()] = void 0, i ? (i[d()] = void 0, n ? (r && !a || !r && !i.dateSelected) && (e.minDate = void 0, i.minDate = void 0) : (r && !i.dateSelected || !r && !a) && (e.maxDate = void 0, i.maxDate = void 0)) : e[h()] = void 0;else {
        if (!g(t)) throw "Invalid date passed to ".concat(f());
        i ? ((r && n && c > (a || s) || r && !n && c < (i.dateSelected || o) || !r && n && c > (i.dateSelected || s) || !r && !n && c < (a || o)) && v(), e[d()] = c, i[d()] = c, (n && (r && !a || !r && !i.dateSelected) || !n && (r && !i.dateSelected || !r && !a)) && (e[h()] = c, i[h()] = c)) : ((n && c > (a || s) || !n && c < (a || o)) && v(), e[h()] = c);
      }
      return i && u(i), u(e), e;
    }

    function N() {
      var e = this.first ? this : this.sibling,
          t = e.sibling;
      return {
        start: e.dateSelected,
        end: t.dateSelected
      };
    }

    function E() {
      var e = this,
          t = this.inlinePosition,
          n = this.parent,
          a = this.calendarContainer,
          i = this.el,
          o = this.sibling;
      t && (r.some(function (t) {
        return t !== e && t.parent === n;
      }) || n.style.setProperty("position", null));

      for (var s in a.remove(), r = r.filter(function (e) {
        return e.el !== i;
      }), o && delete o.sibling, this) {
        delete this[s];
      }

      r.length || l.forEach(function (e) {
        return document.removeEventListener(e, L);
      });
    }

    e.exports = function (e, t) {
      r.length || l.forEach(function (e) {
        return document.addEventListener(e, L);
      });

      var n = function (e, t) {
        var n = e;
        "string" == typeof n && (n = "#" === n[0] ? document.getElementById(n.slice(1)) : document.querySelector(n));

        var l = function (e, t) {
          if (r.some(function (e) {
            return e.el === t;
          })) throw "A datepicker already exists on that element.";
          var n = d(e);
          ["startDate", "dateSelected", "minDate", "maxDate"].forEach(function (e) {
            var t = n[e];
            if (t && !g(t)) throw '"options.'.concat(e, '" needs to be a valid JavaScript Date object.');
            n[e] = q(t);
          });
          var o = n.position,
              l = n.maxDate,
              u = n.minDate,
              h = n.dateSelected,
              f = n.overlayPlaceholder,
              v = n.overlayButton,
              m = n.startDay,
              y = n.id;
          if (n.startDate = q(n.startDate || h || new Date()), n.disabledDates = (n.disabledDates || []).map(function (e) {
            var t = +q(e);
            if (!g(e)) throw 'You supplied an invalid date to "options.disabledDates".';
            if (t === +q(h)) throw '"disabledDates" cannot contain the same date as "dateSelected".';
            return t;
          }), n.hasOwnProperty("id") && null == y) throw "Id cannot be `null` or `undefined`";

          if (y || 0 === y) {
            var p = r.filter(function (e) {
              return e.id === y;
            });
            if (p.length > 1) throw "Only two datepickers can share an id.";
            p.length ? (n.second = !0, n.sibling = p[0]) : n.first = !0;
          }

          var b,
              D,
              w,
              S,
              M = ["tr", "tl", "br", "bl", "c"].some(function (e) {
            return o === e;
          });
          if (o && !M) throw '"options.position" must be one of the following: tl, tr, bl, br, or c.';
          if (n.position = (b = a(o || "bl", 2), D = b[0], w = b[1], (S = {})[s[D]] = 1, w && (S[s[w]] = 1), S), l < u) throw '"maxDate" in options is less than "minDate".';

          if (h) {
            var x = function x(e) {
              throw '"dateSelected" in options is '.concat(e ? "less" : "greater", ' than "').concat(e || "mac", 'Date".');
            };

            u > h && x("min"), l < h && x();
          }

          if (["onSelect", "onShow", "onHide", "onMonthChange", "formatter", "disabler"].forEach(function (e) {
            "function" != typeof n[e] && (n[e] = c);
          }), ["customDays", "customMonths", "customOverlayMonths"].forEach(function (e, t) {
            var a = n[e],
                r = t ? 12 : 7;

            if (a) {
              if (!Array.isArray(a) || a.length !== r || a.some(function (e) {
                return "string" != typeof e;
              })) throw '"'.concat(e, '" must be an array with ').concat(r, " strings.");
              n[t ? t < 2 ? "months" : "overlayMonths" : "days"] = a;
            }
          }), m && m > 0 && m < 7) {
            var L = (n.customDays || i).slice(),
                P = L.splice(0, m);
            n.customDays = L.concat(P), n.startDay = +m, n.weekendIndices = [L.length - 1, L.length];
          } else n.startDay = 0, n.weekendIndices = [6, 0];

          return "string" != typeof f && delete n.overlayPlaceholder, "string" != typeof v && delete n.overlayButton, n;
        }(t || {
          startDate: q(new Date()),
          position: "bl"
        }, n),
            u = l.startDate,
            h = l.dateSelected,
            f = l.sibling,
            v = n === document.body,
            m = v ? document.body : n.parentElement,
            y = document.createElement("div"),
            b = document.createElement("div");

        y.className = "qs-datepicker-container qs-hidden", b.className = "qs-datepicker";
        var D = {
          el: n,
          parent: m,
          nonInput: "INPUT" !== n.nodeName,
          noPosition: v,
          position: !v && l.position,
          startDate: u,
          dateSelected: h,
          disabledDates: l.disabledDates,
          minDate: l.minDate,
          maxDate: l.maxDate,
          noWeekends: !!l.noWeekends,
          weekendIndices: l.weekendIndices,
          calendarContainer: y,
          calendar: b,
          currentMonth: (u || h).getMonth(),
          currentMonthName: (l.months || o)[(u || h).getMonth()],
          currentYear: (u || h).getFullYear(),
          setDate: O,
          remove: E,
          setMin: Y,
          setMax: C,
          show: P,
          hide: k,
          onSelect: l.onSelect,
          onShow: l.onShow,
          onHide: l.onHide,
          onMonthChange: l.onMonthChange,
          formatter: l.formatter,
          disabler: l.disabler,
          months: l.months || o,
          days: l.customDays || i,
          startDay: l.startDay,
          overlayMonths: l.overlayMonths || (l.months || o).map(function (e) {
            return e.slice(0, 3);
          }),
          overlayPlaceholder: l.overlayPlaceholder || "4-digit year",
          overlayButton: l.overlayButton || "Submit",
          disableYearOverlay: !!l.disableYearOverlay,
          disableMobile: !!l.disableMobile,
          isMobile: "ontouchstart" in window,
          alwaysShow: !!l.alwaysShow,
          id: l.id,
          showAllDates: !!l.showAllDates,
          respectDisabledReadOnly: !!l.respectDisabledReadOnly,
          first: l.first,
          second: l.second
        };

        if (f) {
          var w = f,
              M = D,
              x = w.minDate || M.minDate,
              L = w.maxDate || M.maxDate;
          M.sibling = w, w.sibling = M, w.minDate = x, w.maxDate = L, M.minDate = x, M.maxDate = L, w.originalMinDate = x, w.originalMaxDate = L, M.originalMinDate = x, M.originalMaxDate = L, w.getRange = N, M.getRange = N;
        }

        h && p(n, D);
        var j = getComputedStyle(m).position;
        return v || j && "static" !== j || (D.inlinePosition = !0, m.style.setProperty("position", "relative")), D.inlinePosition && r.forEach(function (e) {
          e.parent === D.parent && (e.inlinePosition = !0);
        }), r.push(D), y.appendChild(b), m.appendChild(y), D.alwaysShow && S(D), D;
      }(e, t),
          h = n.startDate,
          f = n.dateSelected,
          v = n.alwaysShow;

      if (n.second) {
        var m = n.sibling;
        y({
          instance: n,
          deselect: !f
        }), y({
          instance: m,
          deselect: !m.dateSelected
        }), u(m);
      }

      return u(n, h || f), v && D(n), n;
    };
  }, function (e, t, n) {}]);
});